module.exports = __webpack_public_path__ + "img/FGr_Elektroversorgung.7935028a.svg";